import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeDatepickerModule } from 'se-fe-datepicker'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { DobSelectComponent } from './dob-select/dob-select.component'

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'

@NgModule({
  declarations: [DobSelectComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeDatepickerModule,
    SeFeFormFieldModule,
    SeFeTranslationsModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [DobSelectComponent]
})
export class SharedUiDobSelectModule {}
